import axios from 'axios';

export default {
  namespaced: true,
  state: {
    dynamicValidateForm: {
      name: '',
      keyList: [
        {
          key: '',
          keyType: 1
        }
      ],
      desc: '',
      msgType: 2
    },
    updated: false,
    id: ''
  },
  mutations: {
    dynamicValidate(state, { list }) {
      if (list) {
        state.dynamicValidateForm.name = list.keywordReplyRuleVo.ruleName;
        state.dynamicValidateForm.desc = list.keywordReplyRuleVo.replyContent;
        state.dynamicValidateForm.msgType = list.keywordReplyRuleVo.msgType;
        state.dynamicValidateForm.keyList = [];
        list.list.forEach(item => {
          const itm = {
            key: item.keyword,
            keyType: item.matchType
          };
          state.dynamicValidateForm.keyList.push(itm);
        });
      } else {
        state.dynamicValidateForm = {
          name: '',
          keyList: [
            {
              key: '',
              keyType: 1
            }
          ],
          desc: '',
          msgType: 2
        };
      }
    },
    setUpdated(state, value) {
      state.updated = value;
    },
    setId(state, value) {
      state.id = value;
    }
  },
  actions: {
    getKeyReply({ commit }, params) {
      return axios.get('/wxnews/ajax/getKeyReply', {
        params: params,
      }).then((data) => {
        commit({ type: 'dynamicValidate', list: data.data });
        return data;
      });
    },
    setKeyReply({ commit }, params) {
      return axios.post('/wxnews/ajax/setKeyReply', params).then((data) => {
        return data;
      });
    },
    modifyKeyReply({ commit }, params) {
      return axios.post('/wxnews/ajax/modifyKeyReply', params).then((data) => {
        return data;
      });
    },
    getKeyReplyInit({ commit }, params) {
      commit({ type: 'dynamicValidate', list: null });
      return null;
    },
  },
};
